import { createSelector } from 'reselect';
import { format } from 'date-fns';

export const selectStateMenu = () => state => state.menu;

export const selectMenus = () =>
  createSelector(
    selectStateMenu(),
    stateMenu => Object.keys(stateMenu.menus).map(key => stateMenu.menus[key])
  );

export const selectDayMenu = () =>
  createSelector(
    selectMenus(),
    menus =>
      menus.find(menu => menu.menuDate === format(new Date(), 'YYYY-MM-DD'))
  );

export const selectAllergensUrl = () =>
  createSelector(
    selectStateMenu(),
    stateMenu => stateMenu.allergensUrl
  );

export const selectWellnessMenuUrl = () =>
  createSelector(
    selectStateMenu(),
    stateMenu => stateMenu.wellnessMenuUrl
  );
